import React from "react";
import { useLang } from "@/context/LanguageContext";
import { HeartIcon, PawIcon } from "@/components/Icons";
import Reveal from "@/components/Reveal";

const About = () => {
  const { t } = useLang();
  return (
    <section id="about" className="py-20 sm:py-28 relative overflow-hidden" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <Reveal className="lg:col-span-5 flex justify-center">
          <div className="relative">
            <div className="absolute -inset-6 rounded-full bg-gradient-to-br from-[#f7c5c0] to-[#f4956a] blur-2xl opacity-50" />
            <div className="relative w-64 h-64 sm:w-80 sm:h-80 rounded-full overflow-hidden border-8 border-white shadow-2xl">
              <img
                src="/images/carol.jpg"
                alt="Caroline Sousa"
                className="w-full h-full object-cover"
                data-testid="about-photo"
              />
            </div>
            <div className="absolute -bottom-3 -right-3 bg-white rounded-2xl px-4 py-3 shadow-xl flex items-center gap-2">
              <HeartIcon size={18} className="text-[#f4956a]" />
              <span className="font-display text-[#6b3f2a] text-sm">{t.about.badge}</span>
            </div>
            <div className="absolute -top-2 -left-2 bg-[#a8d5ba] rounded-full w-12 h-12 flex items-center justify-center shadow-lg">
              <PawIcon size={22} className="text-white" />
            </div>
          </div>
        </Reveal>

        <Reveal delay={150} className="lg:col-span-7">
          <span className="font-script text-3xl text-[#f4956a]">{t.about.kicker} 🌸</span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-2 mb-6">{t.about.title}</h2>
          <p className="text-[#6b3f2a]/85 leading-relaxed mb-4 text-sm sm:text-base">{t.about.p1}</p>
          <p className="text-[#6b3f2a]/85 leading-relaxed text-sm sm:text-base">{t.about.p2}</p>

          <div className="mt-8 flex flex-wrap gap-3">
            <a href="#contact" className="btn-primary" data-testid="about-cta">
              <PawIcon size={16} /> {t.hero.ctaSecondary}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default About;
